import naja from 'naja';

/**
 * Formuláře v modálech captchu neinicializují – reCAPTCHA v3 má posluchač
 * delegovaný na document (xart-utils/ReCaptchaV3), takže obslouží i formulář
 * dotažený AJAXem. Dřívější volání invisibleRecaptcha() patřilo k v2, hledalo
 * `.g-recaptcha` (v3 pole má `js-recaptcha-v3`) a sahalo na globální
 * `grecaptcha`, které na stránce bez v3 pole vůbec nevznikne – ReferenceError
 * pak shodil celý posluchač včetně moveSubmitToModalFooter().
 */

document.addEventListener('shown.bs.modal', (event: Event) => {
  const modal = event.target
  if (!(modal instanceof HTMLElement)) return
  if (modal.id !== 'basic_modal') return

  const parentElement = modal.querySelector('.modal-body') ?? modal

  import('xart-utils/filePond').then(({ initFilepond }) => {
    initFilepond(parentElement)
  })
})

naja.snippetHandler.addEventListener('afterUpdate', e => {
    const snippet = e.detail.snippet
    const form = snippet.querySelector('form')
    if (!form) return
    moveSubmitToModalFooter(form.id,true);
})

naja.addEventListener('success', (event) => {
  const { payload } = event.detail;
  if (payload?.modal) {
    if (payload?.modal['size']) {
      setModalSize('basic_modal', payload.modal['size']);
    }

    if (payload?.modal['formId']) {
      moveSubmitToModalFooter(payload.modal['formId'],false);
    }
  }
});


function setModalSize(modalId: string, size?: 'sm' | 'lg' | 'xl' | 'fullscreen') {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  const dialog = modal.querySelector('.modal-dialog');
  if (!dialog) return;

  // Odebereme všechny velikostní třídy
  dialog.classList.remove('modal-sm', 'modal-lg', 'modal-xl', 'modal-fullscreen');

  // Přidáme novou velikost, pokud je zadána
  if (size) {
    dialog.classList.add(size === 'fullscreen' ? 'modal-fullscreen' : `modal-${size}`);
  }
}


function moveSubmitToModalFooter(formId: string, clearFooterFirst: boolean = false): void
{
  const form = document.getElementById(formId) as HTMLFormElement | null
  if (!form) return

  const modal = form.closest<HTMLElement>('.modal')
  if (!modal) return

  const footer = modal.querySelector<HTMLDivElement>('.modal-footer')
  if (!footer) return

  const start = footer.querySelector<HTMLDivElement>('.start')
  const end = footer.querySelector<HTMLDivElement>('.end')
  if (!start || !end) return
  if (!end.classList.contains('d-flex')) {
    end.classList.add('d-flex')
  }
  if (clearFooterFirst) {
      start.innerHTML = ''
      end.innerHTML = ''
  }

  const submit = form.querySelector<HTMLInputElement>('input[type="submit"]')
  if (!submit) return

  const wrapper = submit.parentElement
  if (!wrapper) return

  // zajistit vazbu submitu na form (footer je mimo form)
  submit.setAttribute('form', form.id)

  // odebrat submit z wrapperu a wrapper smazat
  submit.remove()
  wrapper.remove()

  const closeBtn = document.createElement('button')
  closeBtn.type = 'button'
  closeBtn.className = 'btn btn-secondary me-2'
  closeBtn.textContent = 'Zavřít'
  closeBtn.setAttribute('data-bs-dismiss', 'modal')

  end.appendChild(closeBtn)
  end.appendChild(submit)

  if (!modal.dataset.footerCleanupBound) {
    modal.dataset.footerCleanupBound = 'true'

    modal.addEventListener('hidden.bs.modal', () => {
      start.innerHTML = ''
      end.innerHTML = ''
    })
  }
}
